import React from 'react';

import svg from './assets/icons-tiktok.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconTiktok = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-tiktok" />
);
